import React, { useState, useEffect } from "react";
import "./Careers.css";

type Tab = "fulltime" | "internship" | "courses";

export const FULL_TIME = [
  { title: "Full Stack Developer Trainee",    dept: "Engineering", loc: "Remote", exp: "0–3 Yrs", skills: ["React","Node.js","TypeScript","MySQL"],          desc: "Build end-to-end web applications on a modern stack in an agile environment." },
  { title: "AI / ML Engineer Trainee",        dept: "Data & AI",   loc: "Remote",          exp: "0–3 Yrs", skills: ["Python","TensorFlow","PyTorch","AWS"],            desc: "Design and deploy intelligent models — NLP, computer vision, prediction systems." },
  // { title: "DevOps Engineer",         dept: "Infra",       loc: "Remote",           exp: "2–3 Yrs", skills: ["Docker","Kubernetes","AWS","CI/CD"],              desc: "Manage cloud infrastructure and build robust deployment pipelines." },
  // { title: "UI/UX Designer",          dept: "Design",      loc: "Chennai / Remote", exp: "1–3 Yrs", skills: ["Figma","Adobe XD","Prototyping","Research"],      desc: "Create beautiful, conversion-focused user experiences across web and mobile." },
  { title: "Application Developer Trainee",    dept: "Engineering", loc: "Remote",          exp: "0–3 Yrs", skills: ["React Native","Flutter","iOS","Android"],          desc: "Build high-performance cross-platform apps for enterprise clients." },
  { title: "Trainer",  dept: "Training",    loc: "Remote",          exp: "2–5 Yrs", skills: [
  "Software Development",
  "Programming",
  "Problem Solving",
  "Technical Training",
  "Mentoring",
  "Communication Skills",
  "Presentation Skills",
  "Project Guidance",
  "Curriculum Development",
  "Team Collaboration"
],   desc: "Conduct training sessions, mentor learners, provide project guidance, prepare training materials, and help students build practical software development skills." },
];

export const INTERNSHIPS = [
  // { title: "Frontend Dev Intern",   dept: "Engineering", dur: "3–6 Months", stipend: "₹8K–12K/mo", skills: ["React","HTML/CSS","JavaScript"],              desc: "Work alongside seniors building real client-facing web apps." },
  { title: "Frontend Dev Intern",   dept: "Engineering", dur: "3–6 Months",  skills: ["React","HTML/CSS","JavaScript"],              desc: "Work alongside seniors building real client-facing web apps." },
  { title: "Backend Dev Intern",    dept: "Engineering", dur: "3–6 Months",  skills: ["Node.js","NestJS","MySQL","REST APIs"],         desc: "Build APIs, server logic and database integrations in production." },
  { title: "AI / ML Intern",        dept: "Data & AI",   dur: "3–6 Months", skills: ["Python","Scikit-learn","Data Analysis"],        desc: "Assist in developing ML models and data pipelines for real projects." },
  { title: "UI/UX Design Intern",   dept: "Design",      dur: "2–4 Months",  skills: ["Figma","Wireframing","User Research"],           desc: "Design interfaces and conduct UX research for our client portfolio." },
  { title: "Digital Marketing Intern",dept:"Marketing",  dur: "2–3 Months",   skills: ["SEO","Social Media","Content","Analytics"],      desc: "Drive growth through content creation, SEO and social campaigns." },
  { title: "Mobile App Dev Intern",  dept: "Engineering", dur: "3–6 Months",  skills: ["React Native","Flutter","Firebase"],             desc: "Develop features and fix bugs under expert mentorship." },
];

export const COURSES = [
  { icon:"🤖", title:"AI / Machine Learning",        dur:"4 Months", mode:"Online + Offline", level:"Beginner → Advanced",     price:"₹15,000", popular:true,  color:"#00cfff",  highlights:["Python Fundamentals","ML Algorithms","Deep Learning","NLP Basics","Real-World Projects","Certificate"] },
  { icon:"📊", title:"Data Science",                 dur:"3 Months", mode:"Online + Offline", level:"Beginner → Intermediate",  price:"₹12,000", popular:false, color:"#a100ff",  highlights:["Statistics & Probability","Pandas & NumPy","SQL","Data Visualisation","Capstone Project"] },
  { icon:"🎮", title:"Game Development",             dur:"3 Months", mode:"Online",           level:"Beginner → Intermediate",  price:"₹10,000", popular:false, color:"#ff6b35",  highlights:["Unity Engine","C# Scripting","2D & 3D Games","Physics","Publishing to Stores"] },
  { icon:"💻", title:"Full Stack Development",       dur:"5 Months", mode:"Online + Offline", level:"Beginner → Advanced",     price:"₹18,000", popular:true,  color:"#00cfff",  highlights:["HTML/CSS/JS","React & Node.js","Databases","REST APIs","Deployment & DevOps"] },
  { icon:"📱", title:"Mobile App Development",       dur:"3 Months", mode:"Online + Offline", level:"Intermediate",            price:"₹12,000", popular:false, color:"#25D366",  highlights:["React Native","Flutter Basics","Firebase","API Integration","App Store Deploy"] },
  { icon:"🔒", title:"Cyber Security",               dur:"4 Months", mode:"Online + Offline", level:"Beginner → Advanced",     price:"₹16,000", popular:false, color:"#E1306C",  highlights:["Network Security","Ethical Hacking","VAPT","Kali Linux","CEH Prep"] },
  { icon:"🧪", title:"Software Testing",             dur:"2 Months", mode:"Online",           level:"Beginner",                price:"₹8,000",  popular:false, color:"#f5c518",  highlights:["Manual Testing","Selenium Basics","JIRA","Agile QA","Test Case Writing"] },
  { icon:"🌐", title:"Networking",                   dur:"3 Months", mode:"Online + Offline", level:"Beginner → Advanced",     price:"₹10,000", popular:false, color:"#0A66C2",  highlights:["CCNA Fundamentals","TCP/IP Stack","Routing & Switching","Network Config","Labs"] },
  { icon:"📣", title:"Digital Marketing",            dur:"2 Months", mode:"Online",           level:"Beginner",                price:"₹7,000",  popular:false, color:"#ff6b35",  highlights:["SEO & SEM","Google Ads","Social Media Marketing","Email Marketing","Analytics"] },
  { icon:"🔧", title:"Web Development",              dur:"3 Months", mode:"Online + Offline", level:"Beginner",                price:"₹9,000",  popular:false, color:"#a100ff",  highlights:["HTML5 & CSS3","JavaScript","Bootstrap","React Basics","Portfolio Project"] },
  { icon:"☁️", title:"AWS Cloud & DevOps Engineering",dur:"4 Months",mode:"Online + Offline", level:"Intermediate → Advanced", price:"₹18,000", popular:true,  color:"#FF9900",  highlights:["AWS Core Services","Docker & Kubernetes","CI/CD Pipelines","Terraform","AWS Cert Prep"] },
];

const Careers: React.FC = () => {
  const [tab, setTab] = useState<Tab>("fulltime");

  const [showModal, setShowModal] = useState(false);
const [selectedJob, setSelectedJob] = useState<any>(null);

const [loading, setLoading] = useState(false);

const [successMsg, setSuccessMsg] = useState('');
const [errorMsg, setErrorMsg] = useState('');

const [form, setForm] = useState({
  name: '',
  email: '',
  phone: '',
  skills: '',
  experience: '',
  message: '',
  resume: null as File | null,
});

// const openModal = (job: any) => {
//   setSelectedJob(job);
//   setShowModal(true);

//   setSuccessMsg('');
//   setErrorMsg('');
// };
const [jobType, setJobType] = useState<'fulltime' | 'internship'>('fulltime');

const openModal = (
  job: any,
  type: 'fulltime' | 'internship'
) => {
  setSelectedJob(job);
  setJobType(type);
  setShowModal(true);

  setSuccessMsg('');
  setErrorMsg('');
};

const closeModal = () => {
  setShowModal(false);
  setSelectedJob(null);
  setJobType('fulltime');
  setForm({
    name: '',
    email: '',
    phone: '',
    skills: '',
    experience: '',
    message: '',
    resume: null,
  });

  setSuccessMsg('');
  setErrorMsg('');
};

const handleChange = (
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
) => {
  const { name, value } = e.target;

  setForm((prev) => ({
    ...prev,
    [name]: value,
  }));
};

const handleFileChange = (
  e: React.ChangeEvent<HTMLInputElement>
) => {
  const file = e.target.files?.[0] || null;

  setForm((prev) => ({
    ...prev,
    resume: file,
  }));
};

const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();

  if (!form.resume) {
    setErrorMsg('Please upload your resume');
    return;
  }

  setLoading(true);
  setSuccessMsg('');
  setErrorMsg('');

  const formData = new FormData();

  formData.append('name', form.name);
  formData.append('email', form.email);
  formData.append('phone', form.phone);
  formData.append('skills', form.skills);
  if (jobType === 'fulltime') {
  formData.append('experience', form.experience);
  formData.append('message', form.message);
}
  formData.append('job_title', selectedJob.title);
  formData.append('resume', form.resume);

  try {
          const apiUrl =
        jobType === 'internship'
          ? 'https://ajera-infotech-backend.onrender.com/internship-apply'
          : 'https://ajera-infotech-backend.onrender.com/careers/apply';
          // ? 'http://localhost:4000/careers/internship-apply'
          // : 'http://localhost:4000/careers/apply';

      const response = await fetch(apiUrl, {
        method: 'POST',
        body: formData,
      });

    const result = await response.json();

    if (result.success) {
      setSuccessMsg(
        '✅ Application submitted successfully.'
      );

      setTimeout(() => {
        closeModal();
      }, 2500);
    } else {
      setErrorMsg(
        result.message || 'Failed to submit application'
      );
    }
  } catch (err) {
    setErrorMsg(
      '❌ Server error. Please try again later.'
    );
  } finally {
    setLoading(false);
  }
};

  /* read hash on mount */
  useEffect(() => {
    const hash = window.location.hash;
    if (hash === "#internship") setTab("internship");
    else if (hash === "#courses") setTab("courses");
    else setTab("fulltime");
  }, []);

  return (
    <div className="careers">
      {/* ── PAGE HERO ── */}
      <section className="careers-hero">
        <div className="careers-hero__bg" />
        <div className="container">
          <span className="section-label">Join Our Team</span>
          <h1 className="careers-hero__title">
            Build Your Career at <span className="gradient-text">AJERA IT</span>
          </h1>
          <p className="careers-hero__sub">
            Whether you're looking for a full-time role, a hands-on internship, or want
            to upskill with industry-ready courses — we have the right path for you.
          </p>
          <div className="careers-hero__stats">
            <div className="careers-hero__stat"><span>{FULL_TIME.length}+</span><small>Open Positions</small></div>
            <div className="careers-hero__stat"><span>{COURSES.length}</span><small>Courses</small></div>
            <div className="careers-hero__stat"><span>30+</span><small>Students Trained</small></div>
            <div className="careers-hero__stat"><span>100%</span><small>Placement Support</small></div>
          </div>
        </div>
      </section>

      {/* ── TABS ── */}
      <div className="careers-tabs">
        <div className="container">
          <div className="careers-tabs__row">
            {([
              { id: "fulltime",   icon: "💼", label: "Full Time Jobs", count: FULL_TIME.length },
              { id: "internship", icon: "🎓", label: "Internship",     count: INTERNSHIPS.length },
              { id: "courses",    icon: "📚", label: "Courses",        count: COURSES.length },
            ] as { id: Tab; icon: string; label: string; count: number }[]).map((t) => (
              <button
                key={t.id}
                id={t.id}
                className={`careers-tab ${tab === t.id ? "careers-tab--active" : ""}`}
                onClick={() => setTab(t.id)}
              >
                <span className="careers-tab__icon">{t.icon}</span>
                <span className="careers-tab__label">{t.label}</span>
                <span className="careers-tab__count">{t.count}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* ── FULL TIME ── */}
      {tab === "fulltime" && (
        <section className="careers-section">
          <div className="container">
            <div className="careers-section__hdr">
              <span className="section-label">Open Roles</span>
              <h2 className="section-title">Full Time Opportunities</h2>
              <p className="section-subtitle">Join a talented, collaborative team and work on meaningful products.</p>
            </div>
            <div className="jobs-grid">
              {FULL_TIME.map((job, i) => (
                <div key={i} className="job-card" style={{ animationDelay: `${i * 0.06}s` }}>
                  <div className="job-card__top">
                    <div>
                      <h3 className="job-card__title">{job.title}</h3>
                      <span className="job-card__dept">{job.dept}</span>
                    </div>
                    <span className="job-card__badge">Full Time</span>
                  </div>
                  <p className="job-card__desc">{job.desc}</p>
                  <div className="job-card__meta">
                    <span>📍 {job.loc}</span>
                    <span>💼 {job.exp}</span>
                  </div>
                  <div className="job-card__skills">
                    {job.skills.map(s => <span key={s} className="skill-chip">{s}</span>)}
                  </div>
                  {/* <button
                    type="button"
                    className="job-card__apply"
                    onClick={() => openModal(job)}
                  >
                    Apply Now →
                  </button> */}
                  <a
                    href="#"
                    className="job-card__apply"
                    // onClick={(e) => {
                    //   e.preventDefault();
                    //   openModal(job);
                    // }}
                      onClick={(e) => {
                      e.preventDefault();
                      openModal(job, 'fulltime');
                    }}
                  >
                    Apply Now →
                  </a>
                </div>
              ))}
            </div>
            <div className="careers-no-match">
              <h3>Don't see your role?</h3>
              <p>We're always on the lookout for talented people. Send your resume and we'll reach out.</p>
              <a href="mailto:contact@ajeragroup.com" className="btn-primary">Send Your Resume</a>
            </div>
          </div>
        </section>
      )}

      {/* ── INTERNSHIP ── */}
      {tab === "internship" && (
        <section className="careers-section">
          <div className="container">
            <div className="careers-section__hdr">
              <span className="section-label">Internship Program</span>
              <h2 className="section-title">Learn While You Build</h2>
              <p className="section-subtitle">Real projects, expert mentors, and a certificate to launch your career.</p>
            </div>
            <div className="intern-benefits">
              {[
                { icon:"🎯", t:"Real Projects",      d:"Work on live client work, not toy apps." },
                { icon:"👨‍🏫", t:"Expert Mentors",    d:"Learn from senior engineers & designers." },
                { icon:"📜", t:"Certificate",         d:"Industry-recognized completion certificate." },
                { icon:"💼", t:"PPO Opportunity",     d:"Top performers get Pre-Placement Offers." },
              ].map((b,i)=>(
                <div key={i} className="intern-benefit">
                  <span className="intern-benefit__icon">{b.icon}</span>
                  <strong>{b.t}</strong>
                  <p>{b.d}</p>
                </div>
              ))}
            </div>
            <div className="jobs-grid">
              {INTERNSHIPS.map((intern, i) => (
                <div key={i} className="job-card" style={{ animationDelay: `${i * 0.06}s` }}>
                  <div className="job-card__top">
                    <div>
                      <h3 className="job-card__title">{intern.title}</h3>
                      <span className="job-card__dept">{intern.dept}</span>
                    </div>
                    <span className="job-card__badge job-card__badge--intern">Internship</span>
                  </div>
                  <p className="job-card__desc">{intern.desc}</p>
                  <div className="job-card__meta">
                    <span>⏱ {intern.dur}</span>
                   {/* <span>₹ {intern.stipend}</span> */}
                  </div>
                  <div className="job-card__skills">
                    {intern.skills.map(s => <span key={s} className="skill-chip">{s}</span>)}
                  </div>
                  {/* <button
                    type="button"
                    className="job-card__apply"
                    onClick={() => openModal(intern)}
                  >
                    Apply Now →
                  </button> */}

                  <a
                    href="#"
                    className="job-card__apply"
                    // onClick={(e) => {
                    //   e.preventDefault();
                    //   openModal(intern);
                    // }}
                    onClick={(e) => {
                      e.preventDefault();
                      openModal(intern, 'internship');
                    }}
                  >
                    Apply Now →
                  </a>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* ── COURSES ── */}
      {tab === "courses" && (
        <section className="careers-section">
          <div className="container">
            <div className="careers-section__hdr">
              <span className="section-label">Skill Development</span>
              <h2 className="section-title">Professional Courses</h2>
              <p className="section-subtitle">
                Industry-ready courses with hands-on projects, expert instructors and placement support.
              </p>
            </div>
            <div className="courses-grid">
              {COURSES.map((c, i) => (
                <div
                  key={i}
                  className={`course-card ${c.popular ? "course-card--popular" : ""}`}
                  style={{ "--cc": c.color } as React.CSSProperties}
                >
                  {c.popular && <div className="course-card__popular">⭐ Popular</div>}
                  <div className="course-card__head">
                    <span className="course-card__icon">{c.icon}</span>
                    {/* <div className="course-card__price">{c.price}</div> */}
                  </div>
                  <h3 className="course-card__title">{c.title}</h3>
                  <div className="course-card__meta">
                    <span>⏱ {c.dur}</span>
                    <span>📡 {c.mode}</span>
                  </div>
                  <div className="course-card__level">{c.level}</div>
                  <ul className="course-card__highlights">
                    {c.highlights.map(h => (
                      <li key={h}>
                        <span className="course-card__check">✓</span> {h}
                      </li>
                    ))}
                  </ul>
                  <div className="course-card__actions">
                    <a
                      href={`https://wa.me/919751772429?text=Hi, I'm interested in ${encodeURIComponent(c.title)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="course-card__enroll"
                    >
                      <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                      </svg>
                      Enroll via WhatsApp
                    </a>
                  </div>
                </div>
              ))}
            </div>

            {/* Placement banner */}
            <div className="placement-banner">
              <div className="placement-banner__text">
                <h3>🎯 100% Placement Support</h3>
                <p>Resume building, mock interviews &amp; direct referrals to our client network — included in every course.</p>
              </div>
              <a href="https://wa.me/919751772429" target="_blank" rel="noopener noreferrer" className="btn-cyan">
                Talk to a Counsellor
              </a>
            </div>
          </div>
        </section>
      )}

      {showModal && selectedJob && (
  <div
    className="apply-modal"
    onClick={(e) => {
      if (
        (e.target as HTMLElement).classList.contains(
          'apply-modal'
        )
      ) {
        closeModal();
      }
    }}
  >
    <div className="apply-box">
      <div className="apply-header">
        <h2>Apply for {selectedJob.title}</h2>

        <button
          type="button"
          className="close-btn"
          onClick={closeModal}
        >
          ✕
        </button>
      </div>

      <form
        className="apply-form"
        onSubmit={handleSubmit}
      >
        <input
          type="text"
          name="name"
          placeholder="Full Name"
          required
          value={form.name}
          onChange={handleChange}
        />

        <input
          type="email"
          name="email"
          placeholder="Email Address"
          required
          value={form.email}
          onChange={handleChange}
        />

        <input
          type="text"
          name="phone"
          placeholder="Phone Number"
          required
          value={form.phone}
          onChange={handleChange}
        />

        <input
          type="text"
          name="skills"
          placeholder="Skills"
          required
          value={form.skills}
          onChange={handleChange}
        />

        {jobType === 'fulltime' && (
          <input
            type="number"
            name="experience"
            placeholder="Years of Experience"
            required
            value={form.experience}
            onChange={handleChange}
          />
        )}

             {jobType === 'fulltime' && (
                <textarea
                  name="message"
                  placeholder="Why should we hire you?"
                  value={form.message}
                  onChange={handleChange}
                />
              )}

        <input
          type="file"
          accept=".pdf,.doc,.docx"
          required
          onChange={handleFileChange}
        />
        {form.resume && (
          <p className="selected-file">
            📄 {form.resume.name}
          </p>
        )}

        {successMsg && (
          <p className="form-success">
            {successMsg}
          </p>
        )}

        {errorMsg && (
          <p className="form-error">
            {errorMsg}
          </p>
        )}

        <button
          type="submit"
          disabled={loading}
        >
          {loading
            ? 'Submitting...'
            : 'Submit Application'}
        </button>
      </form>
    </div>
  </div>
)}

    </div>
  );
};

export default Careers;
